import * as types from './mutation-types'
import Vue from 'vue'
import { ISocketState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<ISocketState> = {
  [types.SOCKET_ONOPEN](state, event)  {
    //console.info(state, event)
    state.reconnectError = false
    state.isConnected = true 
    state.connectedDate = new Date().toISOString()
  },
  [types.SOCKET_ONKEEPALIVE](state,keepAliveTimoutId:number)  {    
    state.keepAliveTimoutId = keepAliveTimoutId
  },
  [types.SOCKET_ONCLOSE](state, event)  {
    //console.info(state, event)
    state.isConnected = false
  },
  [types.SOCKET_ONERROR](state, event)  {
    console.error(state, event)    
  },
  // mutations for reconnect methods
  [types.SOCKET_RECONNECT](state, count) {    
    //console.info(state, count)
    //state.reconnectError = false
    state.isConnected = false
    state.wasOffline = true
  },
  [types.SOCKET_RECONNECT_ERROR](state) {
    //console.error(state)  
    state.reconnectError = true
    state.isConnected = false
  }
}

export default mutations
